module.exports = __webpack_public_path__ + "media/images/sample@2x-59735ff4f2690b33ad29000906f86a3e.png";